export const CONFIG = {
  // Outgoing Links
  methodologyURL: "https://docs.google.com/document/d/1nrDQKBENkWOq135_9JVHxlmQvNGlcgi_Vpnf3LK5oGc",
}

export default CONFIG;

export const scenarioColors = {
  bau: '#BEBEBE',
  primary: '#BD544A',
  secondary: '#588BE5'
}



// WEBPACK FOOTER //
// ./src/data/config.js